import { cn } from '@lib/utils';

interface WrapperProps {
  children: React.ReactNode;
  className?: string;
}

function Wrapper({ children, className }: WrapperProps) {
  const baseClassName =
    'flex flex-col gap-y-[72px] whitespace-pre-line px-5 py-[72px] md:gap-y-[100px] md:px-8 md:py-[100px] 2xl:mx-auto 2xl:my-0 2xl:max-w-[960px] 2xl:px-0';

  return <div className={cn(baseClassName, className)}>{children}</div>;
}

export default Wrapper;
